<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <app-progress-bar
      [currentStep]="currentStep"
      [totalSteps]="totalSteps"
    ></app-progress-bar>

    <h2 class="text-base font-bold mb-2 mt-2">
      Quelle est votre activité principale ?
    </h2>

    <!-- Grille des 7 activityTypes (filtrés par merchantType) -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-2 mb-3">
      @for (type of activityOptions; track type) {
        <button
          (click)="selectType(type.id)"
          class="p-2 rounded-lg font-medium transition-all duration-200 border-2 flex flex-col items-start text-left w-full"
        [ngClass]="{
          'bg-green-50 dark:bg-green-900/20 border-green-500 text-green-900 shadow-md dark:shadow-slate-900/50':
            selectedType === type.id,
          'bg-gray-50 dark:bg-slate-900 border-gray-200 dark:border-slate-700 text-gray-700 dark:text-gray-300 hover:border-green-300 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800':
            selectedType !== type.id,
        }"
          >
          <div class="flex items-center space-x-1.5">
            <span class="text-lg">{{ type.icon }}</span>
            <span class="text-xs font-medium">{{ type.label }}</span>
          </div>
          <span class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">{{
            type.description
          }}</span>
        </button>
      }
    </div>

    <!-- Détail de l'activité sélectionnée -->
    @if (selectedType) {
      <div
        class="mb-3 p-3 bg-white dark:bg-slate-800 border-2 border-green-400 dark:border-green-700 rounded-lg shadow-lg dark:shadow-slate-900/50 animate-fadeIn"
        >
        <div class="flex items-center gap-2 mb-2 pb-2 border-b border-gray-200 dark:border-slate-700">
          <span class="text-xl">{{ getSelectedOption()?.icon }}</span>
          <h3 class="text-sm font-bold text-gray-800 dark:text-gray-100">
            {{ getSelectedOption()?.label }}
          </h3>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <div class="flex items-center gap-1 mb-1">
              <span class="text-xs font-bold text-purple-700 dark:text-purple-300">💎 CŒUR</span>
              <span class="text-[10px] text-gray-500 dark:text-gray-400">(70-80%)</span>
            </div>
            <ul class="text-xs text-gray-700 dark:text-gray-300 space-y-0.5 pl-2">
              @for (product of getSelectedOption()?.coreProducts; track product) {
                <li
                  class="flex items-start"
                  >
                  <span class="mr-1 text-purple-400">•</span>
                  <span>{{ product }}</span>
                </li>
              }
            </ul>
          </div>
          <div>
            <div class="flex items-center gap-1 mb-1">
              <span class="text-xs font-bold text-blue-700 dark:text-blue-300"
                >➕ COMPLÉMENTAIRES</span
                >
                <span class="text-[10px] text-gray-500 dark:text-gray-400">(15-25%)</span>
              </div>
              <ul class="text-xs text-gray-700 dark:text-gray-300 space-y-0.5 pl-2">
                @for (product of getSelectedOption()?.complementaryProducts; track product) {
                  <li
                    class="flex items-start"
                    >
                    <span class="mr-1 text-blue-400">•</span>
                    <span>{{ product }}</span>
                  </li>
                }
              </ul>
            </div>
            <div>
              <div class="flex items-center gap-1 mb-1">
                <span class="text-xs font-bold text-gray-600 dark:text-gray-400">⭐ OCCASIONNELS</span>
                <span class="text-[10px] text-gray-500 dark:text-gray-400">(~5%)</span>
              </div>
              <ul class="text-xs text-gray-700 dark:text-gray-300 space-y-0.5 pl-2">
                @for (product of getSelectedOption()?.occasionalProducts; track product) {
                  <li
                    class="flex items-start"
                    >
                    <span class="mr-1 text-gray-400">•</span>
                    <span>{{ product }}</span>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }

      <!-- Navigation -->
      <div class="flex justify-between mb-2 mt-3">
        @if (currentStep > 1) {
          <button
            class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-colors bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-slate-600 hover:text-gray-900 dark:hover:text-white dark:text-white"
            [routerLink]="['/onboarding/step', currentStep - 1]"
            >
            ← Précédent
          </button>
        }

        <button
          class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-all"
        [ngClass]="{
          'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md dark:shadow-slate-900/50 hover:shadow-lg dark:shadow-slate-900/50':
            selectedType,
          'bg-gray-200 dark:bg-slate-700 text-gray-400 cursor-not-allowed': !selectedType,
        }"
          [disabled]="!selectedType"
          (click)="continue()"
          >
          Continuer →
        </button>
      </div>
    </div>
  </div>
